import React, { useEffect, useState } from 'react';

function escapeHtml(text) {
  return text
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function markdownToHtml(md) {
  const lines = md.split(/\r?\n/);
  const result = [];
  let inUl = false;
  let inOl = false;

  const closeLists = () => {
    if (inUl) {
      result.push('</ul>');
      inUl = false;
    }
    if (inOl) {
      result.push('</ol>');
      inOl = false;
    }
  };

  for (const line of lines) {
    if (/^###\s+/.test(line)) {
      closeLists();
      result.push(`<h6>${escapeHtml(line.replace(/^###\s+/, ''))}</h6>`);
    } else if (/^##\s+/.test(line)) {
      closeLists();
      result.push(`<h5>${escapeHtml(line.replace(/^##\s+/, ''))}</h5>`);
    } else if (/^#\s+/.test(line)) {
      closeLists();
      result.push(`<h4>${escapeHtml(line.replace(/^#\s+/, ''))}</h4>`);
    } else if (/^\d+\.\s+/.test(line)) {
      if (!inOl) {
        closeLists();
        result.push('<ol>');
        inOl = true;
      }
      result.push(`<li>${escapeHtml(line.replace(/^\d+\.\s+/, ''))}</li>`);
    } else if (/^-\s+/.test(line)) {
      if (!inUl) {
        closeLists();
        result.push('<ul>');
        inUl = true;
      }
      result.push(`<li>${escapeHtml(line.replace(/^-\s+/, ''))}</li>`);
    } else if (line.trim() === '') {
      closeLists();
    } else {
      closeLists();
      result.push(`<p>${escapeHtml(line)}</p>`);
    }
  }
  closeLists();

  let html = result.join('\n');
  html = html.replace(/\*\*(.*?)\*\*/g, '<strong>$1</strong>');
  html = html.replace(/\*(.*?)\*/g, '<em>$1</em>');
  return html;
}

export default function MarkdownPage({ file }) {
  const [html, setHtml] = useState('');

  useEffect(() => {
    fetch(process.env.PUBLIC_URL + '/' + file)
      .then((res) => res.text())
      .then((text) => setHtml(markdownToHtml(text)))
      .catch(() => setHtml('<p>Failed to load document.</p>'));
  }, [file]);

  if (!html) {
    return <div>Loading...</div>;
  }

  return <div dangerouslySetInnerHTML={{ __html: html }} />;
}
